import { useQuery } from '@tanstack/react-query';
import { getMonitoramentosBigNumbers } from '../services';

export const useMonitoramentosBigNumbers = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['monitoramentos-big-numbers'],
    queryFn: getMonitoramentosBigNumbers,
  });

  return {
    totalCriados: data?.data.totalCriados,
    limitePlano: data?.data.limitePlano,
    alertadosUltimos30Dias: data?.data.alertadosUltimos30Dias,
    emAlertaHoje: data?.data.emAlertaHoje,
    isLoading,
  };
};
